export const heroImage = 'https://cdn.magicpatterns.com/uploads/jvAS8d5ftYHR1sq4ubDFEq/ChatGPT_Image_8_sept_2026,_01_57_18-Photoroom_(1).webp';

/** Live checkout link. */
export const checkoutUrl = 'https://yoga-teaching-vault.impultienda.ar/checkout';
export const price = '$27';
export const heroBadges: string[] = ['100% Digital', 'Instant Access', 'Ready-to-Use PDFs', 'Use From Your Next Class', 'For Yoga Teachers Worldwide'];
export const finalBadges: string[] = ['6 Teaching Volumes', '120 Ready-to-Teach Classes', '7 Practical Bonuses', '100% Digital PDFs', 'Immediate Access'];

/** The staccato "planning spiral" of a normal teaching week. */
export const planningSpiral: string[] = ['You open your notes.', 'Scroll through saved posts.', 'Search old sequences.', 'Look through screenshots.', 'Check videos.', 'Write down poses.', 'Change the order.', 'Try to remember what you taught last week.'];

/** And then there are the days when... */
export const hardDays: string[] = ['A substitute request comes in.', 'The group is different than expected.', 'You have no props.', 'A beginner walks in.', 'The room has mixed abilities.', 'You have 15 minutes to prepare.', 'You simply don’t have another fresh sequence in your head.'];

/** What the Vault actually is. */
export const isThis: string[] = ['Ready-to-teach class structures', 'Clear class progression', 'Practical cueing support', 'Different teaching styles', 'Multiple durations and situations', 'Adaptation ideas', 'Mixed-level support', 'Emergency teaching resources', 'Planning tools', 'Quick-reference systems'];
export interface Step {
  code: string;
  title: string;
  description: string;
}
export const steps: Step[] = [{
  code: '01',
  title: 'Open',
  description: 'Access your digital Yoga Teaching Vault™.'
}, {
  code: '02',
  title: 'Choose',
  description: 'Use the Class Finder or browse the six volumes.'
}, {
  code: '03',
  title: 'Review',
  description: 'Read the class and choose any options appropriate for your students.'
}, {
  code: '04',
  title: 'Teach',
  description: 'Bring the structure into your class and teach in your own voice.'
}];

/** Everything included, as listed in the offer section. */
export const included: string[] = ['6 Teaching Volumes — 120 ready-to-teach classes', 'Beginner & Gentle · Hatha · Slow Flow · Mobility', 'Restore · Chair & Mixed-Level teaching', 'All 7 practical teacher bonuses', '60-Second Class Finder + 30 Emergency Classes', '100% digital PDFs · immediate access'];